<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 21v-2h3v-4.1a5.823 5.823 0 0 1-3.575-2C6.475 11.8 6 10.5 6 9V3h12v6c0 1.5-.475 2.8-1.425 3.9a5.823 5.823 0 0 1-3.575 2V19h3v2H8Zm4-8c.933 0 1.75-.283 2.45-.85a4.059 4.059 0 0 0 1.4-2.15h-7.7a4.06 4.06 0 0 0 1.4 2.15c.7.567 1.517.85 2.45.85ZM8 8h8V5H8v3Z"
    />
  </svg>
</template>
